import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currency", "lineItemsFrame", "catalogLink"]
  static values = { 
    confirmMessage: String
  }

  connect() {
    this.originalCurrency = this.currencyTarget.value
    this.updateCatalogLink(this.originalCurrency)
  }

  currencyChanged(event) {
    const newCurrency = event.target.value
    console.log('Currency changed from', this.originalCurrency, 'to', newCurrency)
    
    // If currency actually changed
    if (this.originalCurrency !== newCurrency) {
      const mismatchedItems = this.getMismatchedItems(newCurrency)
      
      // If there are any items (matched or mismatched)
      if (this.hasLineItems()) {
        const message = mismatchedItems.length > 0
          ? `Changing the currency will remove ${mismatchedItems.length} item(s) with different currencies. Continue?`
          : this.confirmMessageValue || "Changing the currency will remove all selected line items. Continue?"
        
        if (confirm(message)) {
          // Remove mismatched items
          this.removeMismatchedItems(mismatchedItems)
          
          // Clear all items if there were no mismatched items (meaning all items get cleared)
          if (mismatchedItems.length === 0) {
            this.clearLineItems()
          }
          
          this.originalCurrency = newCurrency
          this.updateCatalogLink(newCurrency)
        } else {
          // Revert the currency change
          event.target.value = this.originalCurrency
        }
      } else {
        // No items, just update
        this.originalCurrency = newCurrency
        this.updateCatalogLink(newCurrency)
      }
    }
  }

  getMismatchedItems(newCurrency) {
    const frame = this.lineItemsFrameTarget
    const items = frame.querySelectorAll('.job-item-fields')
    const mismatched = []
    
    items.forEach(item => {
      const priceCcyField = item.querySelector('input[name*="[price_ccy]"]')
      if (priceCcyField && priceCcyField.value) {
        const itemCurrency = priceCcyField.value
        if (itemCurrency !== newCurrency) {
          mismatched.push(item)
        }
      }
    })
    
    return mismatched
  }

  removeMismatchedItems(items) {
    items.forEach(item => {
      item.remove()
    })
  }

  updateCatalogLink(currency) {
    if (!this.hasCatalogLinkTarget) {
      return
    }
    
    const url = new URL(this.catalogLinkTarget.href)
    url.searchParams.set('rate_ccy', currency)
    this.catalogLinkTarget.href = url.toString()
  }

  hasLineItems() {
    const frame = this.lineItemsFrameTarget
    const items = frame.querySelectorAll('.job-item-fields')
    return items.length > 0
  }

  clearLineItems() {
    const frame = this.lineItemsFrameTarget
    const turboFrame = frame.querySelector('turbo-frame')
    if (turboFrame) {
      turboFrame.innerHTML = ''
    }
  }
}